import { GoogleAnalytics, gaOptout } from './google-analytics';
import CookieConsent from './cookie-consent';



export default class GprdHelper
{
    constructor()
    {
        window.gaOptout = gaOptout;        
        this.analytics = null;
    }

    initGoogleAnalytics(uacode = null)
    {
        if (uacode) {
            this.analytics = new GoogleAnalytics(uacode);
            this.analytics.init();        
        }
    }

    showCookieConsent(lang = 'de', args)
    {        
        this.lang = lang;
        const options = Object.assign({}, this.getDefaults(), args);
       
        CookieConsent.init(options);
    }

    getDefaults() {
        if (this.analytics) {
            return {
                text: this.getText('note') + this.getText('analytics'),
                acceptText: this.getText('accept'),
                denyText: this.getText('deny'),
                onFirstTime: () => this.analytics.loadScript(),
                onConsent: () => this.analytics.loadScript()
            }
        }
        else {
            return {
                text: this.getText('note'),
                acceptText: this.getText('accept'),
                denyText: false
            }
        }
    }

    getPrivacyUrl() {
        if (this.lang == 'de') {
            return '/datenschutzerklaerung';
        } else {
            return '/privacy-policy';
        }
    }

    getText(key)
    {
        const texts = {
            de: {
                accept: 'Akzeptieren',
                deny: 'Ablehnen',
                okay: 'Verstanden',
                note: 'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, \
                            verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung \
                            von Cookies zu. \
                            Weitere Informationen zu Cookies erhalten Sie in unserer <a href="' + this.getPrivacyUrl() + '" target="_blank">Datenschutzerklärung</a>.',
                analytics: ' Zudem haben Sie die Möglichkeit Tracking-Cookies auf dieser Website (z.B. Google Analytics) zu deaktivieren.'
            },

            en: {
                accept: 'Accept',
                deny: 'Deny',
                okay: 'Okay',
                note: 'To continuously optimise our webperformance this website is making use of Cookies. You automatically accept our Cookie policy by using our website. \
                            Additional information about Cookies are explained in detail in our <a href="' + this.getPrivacyUrl() + '" target="_blank">Privacy Policy.</a>',
                analytics: ' Furthermore you have the oppurtunity to deactivate Tracking Cookies (e.g. Google Analytics) on this website.'
            }
        }

        return texts[this.lang][key];
    }
}
